// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1-6mb","tab":"Tabs_tab__1ppkm","selectedTab":"Tabs_selectedTab__3bVF1"};